import Modal from "components/modal";
import CloseIcon from "assets/icons/close.svg";
import { Button } from "components/button";
import { useState, useCallback } from "react";
import { cancelAppointment } from "components/appointments/service";

export default function CancelAppointmentModal({
  setModalOpen,
  modalOpen,
  storeName,
  appointmentId,
  accessToken,
  takebackId,
  onSuccess,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirmCancel = useCallback(async () => {
    if (!appointmentId || !accessToken || !takebackId) return;

    setIsSubmitting(true);
    try {
      await cancelAppointment(
        appointmentId,
        "appointmentCancelledIntentAt",
        accessToken,
        takebackId
      );

      // Call the success callback to refresh parent data
      if (onSuccess) {
        onSuccess();
      }

      setModalOpen(false);
    } catch (error) {
      console.error("Failed to cancel appointment:", error);
      // You might want to show an error message to the user here
    } finally {
      setIsSubmitting(false);
    }
  }, [appointmentId, accessToken, takebackId, onSuccess, setModalOpen]);

  return (
    <Modal
      setModalOpen={setModalOpen}
      modalOpen={modalOpen}
      className="flex flex-col justify-between max-h-[90vh]"
      disableBackdropClick={isSubmitting}
    >
      <div className="flex flex-col h-full">
        {/* Header */}
        <div className="flex justify-between items-start mb-6">
          <h2 className="text-2xl font-bold text-black">Cancel appointment</h2>
          <div
            className="cursor-pointer p-1 hover:bg-gray-100 rounded-full"
            onClick={() => setModalOpen(false)}
          >
            <img src={CloseIcon} alt="Close" className="w-5 h-5" />
          </div>
        </div>

        {/* Body Content */}
        <div className="flex-1 mb-8">
          <p className="text-base text-secondary mb-4">
            You're about to cancel your appointment at the LEGO Store{" "}
            {storeName}. You won't be able to complete your trade-in without
            one.
          </p>
          <p className="text-base text-secondary">
            You can rebook anytime from your My Trade-Ins Dashboard.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between gap-4">
          <Button
            variant="secondary"
            onClick={() => setModalOpen(false)}
            className="flex-1"
            disabled={isSubmitting}
          >
            Keep Appointment
          </Button>
          <Button
            onClick={handleConfirmCancel}
            className={`flex-1 bg-red hover:bg-red-700 text-white ${
              isSubmitting ? "opacity-50" : ""
            }`}
          >
            {isSubmitting ? "Cancelling..." : "Confirm Cancellation"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
